import { useState ,useEffect} from "react";
import { postAccionRol, deleteAccionRol,  getAccionesRolesLista } from "../../services/AccionesRolesServices";
import { getAccionesLista } from "../../services/AccionesServices";
import { AccionesRolesContext } from "./AccionesRolesContext"

export const AccionesRolesState = ({ children }) => {
 
    const getAccionesRolesListaData = async () => {
        let res = await getAccionesRolesLista()
        return res
    }

    const postAccionRolData = async (body) => {
        const res = await postAccionRol(body)
        if (res) getAccionesRolesListaData()
        return res
    }

    const deleteAccionRolData = async (body) => {
        const res = await deleteAccionRol(body)
        if (res) getAccionesRolesListaData()
        return res
    }

    const getAccionesListaData = async () => {
        let res = await getAccionesLista()
        return res
    }

    return <AccionesRolesContext.Provider value={{
        getAccionesRolesListaData,
        postAccionRolData,
        deleteAccionRolData,
        getAccionesListaData
    }} >
        {children}
    </AccionesRolesContext.Provider>
}